module.exports = __webpack_public_path__ + "img/document.7403929e.png";